import { Field, Form, Formik } from 'formik';
import { Modal } from 'react-bootstrap';
import { IAddEditFormProps } from '../../../models/forms/IForm';
import FormikFormInput from '../../../shared-components/FormikFormHandlers/FormikFormInput';
import { GroupValidateSchema } from '../../../shared-components/FormikFormHandlers/FormikValidationSchema';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import Label from '../../../shared-components/label/label';
import ModalFooter from '../../../shared-components/modal/modal-footer';

interface IProps extends IAddEditFormProps<any> {
  selectedRows: any;
}

const AddEditGroupSettingForm = ({
  id,
  initialValues,
  isLoading,
  submitHandler,
  onModalClosed,
  selectedRows,
}: IProps) => {
  return (
    <>
      <Formik
        initialValues={{ GroupName: '' }}
        enableReinitialize
        validationSchema={GroupValidateSchema}
        validateOnBlur={false}
        onSubmit={async (values) => {
          submitHandler({
            GroupName: values.GroupName,
          });
        }}
      >
        {() => {
          return (
            <Form className="user-form">
              {isLoading && <FormLoader loading={isLoading} />}
              <Modal.Body>
                <div className="row">
                  <div className="col-12">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        required={true}
                        label="group_name"
                      />
                      <Field
                        data-testid="testProcessName"
                        className="form-control"
                        name="GroupName"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                      />
                    </div>
                  </div>
                </div>
              </Modal.Body>
              <ModalFooter
                id={id}
                onModalClosed={onModalClosed}
                isLoading={isLoading}
                saveNextBtn={id > 0 ? 'update' : 'save'}
                backCancelBtn="cancel"
              />
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default AddEditGroupSettingForm;
